import OtpForm from "../components/OtpForm";
import useAuthStore from "../../../store/authStore";
import { getMfaSetup } from "../service/auth_service";
import "../styles/mfa.css";
import { useState, useEffect, useRef } from "react";
import useDocumentTitle from "../../../shared/customHooks/useDocumentTitle";

const MfaSetupPage = () => {
  useDocumentTitle('MFA Setup')
  const userid = useAuthStore((state)=> state.user);
  const username = useAuthStore((state)=> state.inputUserName);
  const [imageString, setImageString] = useState("");
  const [manualEntryKey, setManualEntryKey] = useState("");
  const [showManualKey, setShowManualKey] = useState(false);

  const hasFetched = useRef(false);

  useEffect(() => {
    if (!userid || !username) return;

    if (hasFetched.current) return;   // 🚀 prevents second call
    hasFetched.current = true;

    const getQRcode = async () => {
      try {
        const response = await getMfaSetup({
          userId: Number(userid),
          authKey: username,
        });

        setImageString(response.data.base64QrImage);
        setManualEntryKey(response.data.manualEntryKey);
      } catch {
        setImageString("");
      }
    };

    getQRcode();
  }, [userid, username]);
  return (
    <>

      <div className="container text-center mt-4">


        <div className="qr-container">
          
            <>
              <h2>Configure mobile app</h2>

              <h3><b>Step 1: Download an authenticator app</b></h3>
              <h4>
                If you don’t already have an existing app, please download a trusted
                authenticator app on your mobile device from your app store.
              </h4>
              <h4>
                Examples include Google Authenticator, Microsoft Authenticator,
                Authy, or Duo Mobile.
              </h4>

              <h3><b>Step 2: Link your account with QR code below</b></h3>
              <h4>
                Open your authenticator app and select "Add a new account" or a similar option to scan the QR code below with your phone's camera.
              </h4>

              <h3><b>Step 3: Verify the setup</b></h3>
              <h4>
                After scanning the QR code, your app will show a 6-digit code that refreshes every few seconds.<br/>
              </h4>
              <h4>Enter this 6-digit code into the verification field below to complete setup.</h4>

              <img
                src={`data:image/png;base64,${imageString}`}
                alt="QR Code"
                className="qr-code"
              />
            </>
        </div>
        <div className="mfa-key_toggle_button" onClick={()=>{setShowManualKey((prev) => !prev)}}>
          {!showManualKey ? "Can't scan? Click Here":"Hide setup Key"}
          </div>
        {showManualKey && 
        <div className="mfa-manual">
  <p className="mfa-manual__hint">
    Enter these details manually in your authenticator app instead of scanning.
  </p>
  <p className="mfa-manual__hint" style={{fontWeight:'bold'}}>
    Note: Enter the key without spaces.
  </p>

  <dl className="mfa-manual__list">
    {/* <dt>Account</dt>
    <dd>{username}</dd> */}

    <dt>Key</dt>
    <dd>
      <code className="mfa-manual__key">{manualEntryKey}</code>
    </dd>

    {/* <dt>Type of key</dt>
    <dd>Time based</dd> */}
  </dl>
</div>}

        <OtpForm />
      </div>

    </>
  );
};

export default MfaSetupPage;